(function () {
  'use strict';

  if (window.__cartBundleInit) return;
  window.__cartBundleInit = true;

  function cartHost(el) {
    return el.closest('cart-items') || el.closest('cart-drawer-items');
  }

  function keysOf(el) {
    return (el.dataset.bundleKeys || '').split(',').filter(Boolean);
  }

  function updateBundle(el, updates) {
    const host = cartHost(el);
    const bundle = el.closest('.cart-bundle');
    const sections = host && typeof host.getSectionsToRender === 'function'
      ? host.getSectionsToRender()
      : [];

    if (bundle) bundle.classList.add('cart-bundle--loading');

    const body = JSON.stringify({
      updates: updates,
      sections: sections.map((s) => s.section),
      sections_url: window.location.pathname,
    });

    return fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.errors) {
          showError(bundle, parsedState.errors);
          return;
        }

        renderSections(host, sections, parsedState);

        if (host) host.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        document.dispatchEvent(new CustomEvent('cart:change', {
          detail: { cart: parsedState, sectionId: host ? host.dataset.source : null },
        }));

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        }
      })
      .catch(() => {
        showError(bundle, window.cartStrings ? window.cartStrings.error : 'Could not update the cart.');
      })
      .finally(() => {
        const stillThere = document.getElementById(bundle ? bundle.id : '');
        if (stillThere) stillThere.classList.remove('cart-bundle--loading');
      });
  }

  function renderSections(host, sections, parsedState) {
    sections.forEach((section) => {
      const container = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.section];
      if (!container || !html) return;
      const target = container.querySelector(section.selector) || container;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function showError(bundle, message) {
    if (!bundle) return;
    const text = bundle.querySelector('.cart-item__error-text');
    if (text) text.textContent = message;
  }

  class BundleRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const updates = {};
        keysOf(this).forEach((key) => { updates[key] = 0; });
        if (!Object.keys(updates).length) return;
        updateBundle(this, updates);
      });
    }
  }

  if (!customElements.get('bundle-remove-button')) {
    customElements.define('bundle-remove-button', BundleRemoveButton);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-bundle-toggle]');
    if (!toggle) return;
    event.preventDefault();
    const list = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!list) return;
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    list.hidden = open;
    const label = toggle.querySelector('[data-bundle-toggle-label]');
    if (label) {
      label.textContent = open ? toggle.dataset.showLabel : toggle.dataset.hideLabel;
    }
  });
})();
